import { usePromoModel } from './usePromoModel';

export const useNewRelicLogging = () => {
  const {
    anchorItem,
    experienceTag,
    subExperience
  } = usePromoModel();

  const anchorItemId = anchorItem.itemId;
  const sendDataToNewRelic = (props) => {
    const { actionName, callType } = props;
    // eslint-disable-next-line no-unused-expressions
    window.newrelic?.addPageAction(actionName, {
      callType,
      experienceTag,
      subExperience,
      anchorItemId
      // promotionId, // TODO: promo-expansion
    });
  };
  const sendErrorsToNewRelic = (props) => {
    const { actionName, errorMessage, callType } = props;
    // eslint-disable-next-line no-unused-expressions
    window.newrelic?.addPageAction(actionName, {
      error: errorMessage,
      callType,
      experienceTag,
      subExperience,
      anchorItemId
      // promotionId, // TODO: promo-expansion
    });
  };

  return { sendDataToNewRelic, sendErrorsToNewRelic };
};